import { cn } from "@/lib/utils";
import { type VariantProps, cva } from "class-variance-authority";
import type * as React from "react";

/**
 * Seat and member state is STATE — encode it in form, not just a word, so a
 * roster can be scanned rather than read.
 */
const badgeVariants = cva(
	"inline-flex items-center rounded-full border px-2 py-0.5 text-caption font-medium",
	{
		variants: {
			variant: {
				neutral: "border-divider bg-surface3 text-paragraph",
				active: "border-success-stroke bg-success-surface text-success",
				invited: "border-orange-stroke bg-orange-surface text-orange-text",
				inactive: "border-divider bg-surface3 text-muted1",
				critical: "border-error-stroke bg-error-surface text-error",
			},
		},
		defaultVariants: { variant: "neutral" },
	},
);

export interface BadgeProps
	extends React.HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
	return (
		<span className={cn(badgeVariants({ variant }), className)} {...props} />
	);
}

export { badgeVariants };
